module.exports = __webpack_public_path__ + "img/icon-01.08f9183c.png";